/* Copyright (c) 2023 Xperi. All Rights Reserved. */

import { AnyAction } from 'redux';
import { Diagnostics } from '@tivocorp/tivo-webapp-loggers';
import { ScreenTaskControllerTypes } from '../../core/navigation/ScreenTaskControllerTypes';
import {
    setScreenController,
    setScreenTaskController,
    showGuideScreen,
} from '../screens/screens.reducers';
import { IDLE_USER_THRESHOLD_TIME } from '../../config';
import { ScreenControllerTypes } from '../../core/navigation/ScreenControllerTypes';
import {
    hideAntiburnOsdAction,
    resetAntiburnTimeoutAction,
    showAntiburnOsdAction,
} from './antiburnosd.actions';
import { HIDE_ANTIBURN_OSD, SHOW_ANTIBURN_OSD, UPDATE_ANTIBURN_TIMER } from './antiburnosd.types';
import { hideMenuLanguage } from '../settings/menulanguage/menulanguage.reducers';
import { DeviceModel } from '../../core/device/DeviceModel';
import { PlaybackState } from '../videoplayerui/infobanner/PlaybackTypes';
import { hideOverlayDialog } from '../overlaydialog/overlaydialog.reducers';
import { Log } from '../../core/logging';

const initialState: {
    isActive: boolean;
    antiburnTimer: any;
} = {
    isActive: false,
    antiburnTimer: null,
};

const antiburnOsdReducer = (state = initialState, { type, payload } = <AnyAction>{}) => {
    switch (type) {
        case SHOW_ANTIBURN_OSD:
        case HIDE_ANTIBURN_OSD:
            return {
                ...state,
                isActive: payload.isActive,
            };

        case UPDATE_ANTIBURN_TIMER:
            return {
                ...state,
                antiburnTimer: payload.antiburnTimer,
            };
        default:
            return state;
    }
};

export const hideAntiburnOsd = () => (dispatch: Function, getState: Function) => {
    const { previousScreenTaskController, previousScreenController } = getState().screens;
    Log.i('Antiburn OSD', 'Antiburn OSD is hidden');
    Diagnostics.info('Antiburn OSD', 'Antiburn OSD is hidden');
    dispatch(setScreenController(previousScreenController));
    dispatch(setScreenTaskController(previousScreenTaskController));
    dispatch(hideAntiburnOsdAction());
};

export const showAntiburnOsd = () => (dispatch: Function, getState: Function) => {
    const { isOverlayDialogActive } = getState().overlayDialog;
    if (isOverlayDialogActive) dispatch(hideOverlayDialog());
    Log.i('Antiburn OSD', 'Antiburn OSD is shown');
    Diagnostics.info('Antiburn OSD', 'Antiburn OSD is shown');
    dispatch(setScreenController(ScreenControllerTypes.ANTIBURN_SCREEN));
    dispatch(setScreenTaskController(ScreenTaskControllerTypes.DEFAULT_ANTIBURN_OSD_TASKS));
    dispatch(showAntiburnOsdAction());
};

export const resetAntiburnTimeout = () => (dispatch: Function, getState: Function) => {
    const { screenController } = getState().screens;
    const { antiburnTimer } = getState().antiburnOsd;
    const { playbackState } = getState().videoPlayer;
    const isPlaybackStatePaused =
        playbackState === PlaybackState.PAUSE || playbackState === PlaybackState.STOP;
    clearTimeout(antiburnTimer);
    if (
        screenController !== ScreenControllerTypes.ANTIBURN_SCREEN &&
        screenController !== ScreenControllerTypes.VIDEO_PLAYER
    ) {
        const timer = setTimeout(() => {
            dispatch(showAntiburnOsd());
        }, IDLE_USER_THRESHOLD_TIME);
        dispatch(resetAntiburnTimeoutAction(timer));
    }

    if (screenController === ScreenControllerTypes.VIDEO_PLAYER && !isPlaybackStatePaused) {
        DeviceModel.getTVProperties().disableScreenSaver();
    } else {
        DeviceModel.getTVProperties().enableScreenSaver();
    }
};

/**
 * Below reducers are related to operations on key events.
 */

export const onKeyBackAntiburnOsd = () => (dispatch: Function) => {
    dispatch(hideAntiburnOsd());
};

export const onKeyGuideAntiburn = () => (dispatch: Function) => {
    dispatch(hideMenuLanguage());
    dispatch(hideAntiburnOsdAction());
    dispatch(showGuideScreen());
};

export const onKeyOkAntiburnOsd = () => (dispatch: Function) => {
    dispatch(hideAntiburnOsd());
};

export const onMouseOverAntiburnOsd = () => (dispatch: Function) => {
    dispatch(hideAntiburnOsd());
    dispatch(resetAntiburnTimeout());
};

export default antiburnOsdReducer;
